(() => {
  const initHeroCarousels = () => {
    document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;

      const track = carousel.querySelector('[data-hero-carousel-track]');
      const slides = [...carousel.querySelectorAll('[data-hero-carousel-slide]')];
      const nextButton = carousel.querySelector('[data-hero-carousel-next]');
      const previousButton = carousel.querySelector('[data-hero-carousel-previous]');

      if (!track || slides.length < 1) return;

      carousel.dataset.initialized = 'true';
      let activeIndex = 0;
      let autoplayTimer;
      let isInteracting = false;

      const loadVideo = (video) => {
        if (video.dataset.loaded === 'true') return;

        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });

        if (video.dataset.posterMobile && window.matchMedia('(max-width: 767px)').matches) {
          video.poster = video.dataset.posterMobile;
        }

        video.dataset.loaded = 'true';
        video.load();
      };

      const getIndex = () => {
        const scrollPosition = track.scrollLeft + (track.clientWidth / 2);
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - scrollPosition);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const updateVideoPlayback = () => {
        slides.forEach((slide, index) => {
          slide.querySelectorAll('video').forEach((video) => {
            if (index === activeIndex) {
              loadVideo(video);
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };

      const goTo = (index, behavior = 'smooth') => {
        activeIndex = (index + slides.length) % slides.length;
        const left = slides[activeIndex].offsetLeft;

        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left, behavior });
        } else {
          track.scrollLeft = left;
        }

        updateVideoPlayback();
      };

      const stopAutoplay = () => window.clearInterval(autoplayTimer);

      const startAutoplay = () => {
        stopAutoplay();
        if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        autoplayTimer = window.setInterval(() => {
          if (!isInteracting && document.visibilityState === 'visible') goTo(activeIndex + 1);
        }, 8000);
      };

      track.addEventListener('scroll', () => {
        const nextIndex = getIndex();
        if (nextIndex !== activeIndex) {
          activeIndex = nextIndex;
          updateVideoPlayback();
        }
      }, { passive: true });
      track.addEventListener('pointerdown', () => {
        isInteracting = true;
        stopAutoplay();
      }, { passive: true });
      track.addEventListener('pointerup', () => {
        isInteracting = false;
        startAutoplay();
      }, { passive: true });
      track.addEventListener('pointercancel', () => {
        isInteracting = false;
        startAutoplay();
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadVideo(entry.target);
            observer.unobserve(entry.target);
          });
        }, { root: track, rootMargin: '0px 100% 0px 100%' });

        slides.forEach((slide) => {
          slide.querySelectorAll('video').forEach((video) => videoObserver.observe(video));
        });
      }

      carousel.addEventListener('mouseenter', () => { isInteracting = true; });
      carousel.addEventListener('mouseleave', () => { isInteracting = false; });
      nextButton?.addEventListener('click', () => goTo(activeIndex + 1));
      previousButton?.addEventListener('click', () => goTo(activeIndex - 1));

      updateVideoPlayback();
      startAutoplay();
    });
  };

  const initLegacyCarousels = () => {
    if (typeof window.Swiper !== 'function') return;

    document.querySelectorAll('.swiper-container').forEach((container) => {
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';
      new window.Swiper(container, {
        pagination: { el: '.swiper-pagination', clickable: true },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
        autoplay: { delay: 8000, disableOnInteraction: false },
        loop: true,
        spaceBetween: 10,
      });
    });
  };

  const init = () => {
    initHeroCarousels();
    initLegacyCarousels();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

function startCountdownFor(index) {
  let targetDate = new Date();
  targetDate.setHours(23, 59, 59, 999);

  function update() {
    let now = new Date().getTime();
    let diff = targetDate.getTime() - now;

    if (diff <= 0) {
      diff = 0;
    }

    let days = Math.floor(diff / (1000 * 60 * 60 * 24));
    let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((diff % (1000 * 60)) / 1000);

    document.getElementById("days-" + index).innerText = String(days).padStart(2, "0");
    document.getElementById("hours-" + index).innerText = String(hours).padStart(2, "0");
    document.getElementById("minutes-" + index).innerText = String(minutes).padStart(2, "0");
    document.getElementById("seconds-" + index).innerText = String(seconds).padStart(2, "0");

    setTimeout(update, 1000);
  }

  update();
}

document.querySelectorAll(".countdown-timer").forEach(timer => {
  let i = timer.dataset.timer;
  startCountdownFor(i);
});
